import { BOToothStateDetail } from "./odo/BOToothStateDetail.model";

export class BOToothStateDetailAgrouped {
    toothTypeId: number; // Cambié toothTypeid a toothTypeId (I mayúscula)
    items: BOToothStateDetail[]=[];
    triage:{ id: string; numTriage: number }[]=[
                                               {id:'u', numTriage:0},
                                               {id:'n', numTriage:0},
                                               {id:'b', numTriage:0},
                                               {id:'ut', numTriage:0},
                                               {id:'nt', numTriage:0},
                                               {id:'bt', numTriage:0},]
}
